/* Kawograf — skrypty motywu */
(function () {
  'use strict';

  var d = document;
  d.documentElement.classList.add('kg-anim');

  function $(sel, ctx) { return (ctx || d).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }

  /* ---------- formatowanie kwot (format waluty sklepu) ---------- */
  var moneyFormat = '{{amount_with_comma_separator}} zł';

  function formatMoney(cents, format) {
    function fmt(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    return format.replace(/<[^>]*>/g, '').replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* „179,00 zł” → „179 zł” — czytelniej przy pełnych kwotach */
  function money(cents) {
    return formatMoney(Math.round(cents), moneyFormat).replace(/[.,]00(?=\D*$)/, '');
  }

  /* ---------- pojawianie się sekcji ---------- */
  function initReveal() {
    var els = $$('.kg-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- header ---------- */
  function initHeader() {
    var h = $('[data-kg-header]');
    if (!h) return;
    function onScroll() {
      h.classList.toggle('is-scrolled', window.scrollY > 8);
      d.documentElement.style.setProperty('--kg-header-bottom', Math.max(0, h.getBoundingClientRect().bottom) + 'px');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    var drawer = $('[data-kg-drawer]', h);
    if (drawer) {
      drawer.addEventListener('toggle', function () { onScroll(); d.body.style.overflow = drawer.open ? 'hidden' : ''; });
      $$('a', drawer).forEach(function (a) { a.addEventListener('click', function () { drawer.open = false; }); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.open) drawer.open = false; });
    }
  }

  /* ---------- rotujący pasek ogłoszeń (mobile) ---------- */
  function initRotator() {
    $$('[data-kg-rotator]').forEach(function (r) {
      var items = $$('[data-kg-rotator-item]', r);
      if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, (parseInt(r.getAttribute('data-interval'), 10) || 5) * 1000);
    });
  }

  /* ---------- szacowana dostawa (dni robocze) ---------- */
  function initEta() {
    var days = ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'];
    var months = ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'];
    function addBusinessDays(from, n) {
      var r = new Date(from), added = 0;
      while (added < n) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) added++; }
      return r;
    }
    function label(x) { return days[x.getDay()] + ' ' + x.getDate() + ' ' + months[x.getMonth()]; }
    $$('[data-kg-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 1;
      var max = Math.max(min, parseInt(el.getAttribute('data-max'), 10) || min);
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 13;
      var now = new Date();
      var weekend = now.getDay() === 0 || now.getDay() === 6;
      var extra = (!weekend && now.getHours() >= cutoff) ? 1 : 0;
      var a = addBusinessDays(now, min + extra), b = addBusinessDays(now, max + extra);
      var out = $('[data-kg-eta-date]', el);
      if (out) out.textContent = min === max ? label(a) : label(a) + ' – ' + label(b);
      el.hidden = false;
    });
  }

  /* ---------- galeria ---------- */
  function Gallery(root) {
    if (!root) return null;
    var track = $('[data-kg-track]', root);
    if (!track) return null;
    var slides = $$('[data-kg-slide]', track);
    var thumbs = $$('[data-kg-thumb]', root);
    var dots = $$('[data-kg-dot]', root);
    var count = $('[data-kg-count]', root);
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    function go(i) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) setActive(i);
      }, 60);
    }, { passive: true });
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    $$('[data-kg-prev]', root).forEach(function (b) { b.addEventListener('click', function () { go(current - 1); }); });
    $$('[data-kg-next]', root).forEach(function (b) { b.addEventListener('click', function () { go(current + 1); }); });
    setActive(0);

    return {
      goToMedia: function (id) {
        for (var k = 0; k < slides.length; k++) {
          if (slides[k].getAttribute('data-media-id') === String(id)) { go(k); return; }
        }
      }
    };
  }

  /* ---------- panel zakupu: warianty, zestawy, dodatki, koszyk ---------- */
  function BuyBox(root) {
    var cfgEl = $('[data-kg-config]', root);
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    if (cfg.moneyFormat) moneyFormat = cfg.moneyFormat;

    var variants = cfg.product.variants;
    var form = $('[data-kg-form]', root);
    var cta = $('[data-kg-cta]', root);
    var ctaLabel = $('[data-kg-cta-label]', root);
    var errorEl = $('[data-kg-error]', root);
    var gallery = Gallery($('[data-kg-gallery]', root));
    var optionSets = $$('[data-kg-option]', root);
    var bundleInputs = $$('[data-kg-bundle-input]', root);
    var addons = $$('[data-kg-addon]', root);
    var colorIndex = cfg.colorIndex;

    var swatches = {};
    $$('[data-swatch]', root).forEach(function (el) { swatches[el.value] = el.getAttribute('data-swatch'); });

    var colorValues = [];
    if (colorIndex > -1) {
      variants.forEach(function (v) { var c = v.options[colorIndex]; if (colorValues.indexOf(c) < 0) colorValues.push(c); });
    }
    var mixable = cfg.allowMix && colorIndex > -1 && colorValues.length > 1;

    var selected = optionSets.length
      ? optionSets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; })
      : variants[0].options.slice();
    var units = [];

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < v.options.length; k++) { if (v.options[k] !== opts[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function activeBundle() {
      for (var i = 0; i < bundleInputs.length; i++) if (bundleInputs[i].checked) return bundleInputs[i];
      return null;
    }
    function qtyOf(input) { return input ? Math.max(1, parseInt(input.getAttribute('data-qty'), 10) || 1) : 1; }
    function discountOf(input) {
      if (!input) return { type: 'percent', value: 0 };
      var type = input.getAttribute('data-discount-type') === 'amount' ? 'amount' : 'percent';
      var value = Math.max(0, parseFloat(input.getAttribute('data-discount')) || 0);
      return { type: type, value: type === 'percent' ? Math.min(90, value) : value };
    }

    function resetUnits() {
      units = [];
      for (var i = 0, q = qtyOf(activeBundle()); i < q; i++) units.push(selected.slice());
    }

    function quote(list, discount) {
      var price = 0, compare = 0, ok = list.length > 0;
      list.forEach(function (opts) {
        var v = findVariant(opts);
        if (!v || !v.available) { ok = false; }
        if (!v) return;
        price += discount.type === 'amount' ? Math.max(0, v.price - Math.round(discount.value * 100)) : v.price;
        compare += (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
      });
      var final = discount.type === 'percent' ? Math.round(price * (100 - discount.value) / 100) : price;
      return { final: final, compare: compare, ok: ok };
    }

    function renderUnits(card, active, qty) {
      var box = $('[data-kg-units]', card);
      if (!box) return;
      if (!active || !mixable || qty < 2) { box.hidden = true; box.innerHTML = ''; box.removeAttribute('data-built'); return; }
      if (box.getAttribute('data-built') !== String(qty)) {
        box.innerHTML = '';
        var hint = d.createElement('p');
        hint.className = 'kg-units__hint';
        hint.textContent = cfg.mixHint || 'Każdą sztukę możesz zamówić w innym kolorze:';
        box.appendChild(hint);
        for (var u = 0; u < qty; u++) {
          var row = d.createElement('div');
          row.className = 'kg-unit';
          var name = d.createElement('span');
          name.className = 'kg-unit__name';
          name.innerHTML = 'Sztuka ' + (u + 1) + ' · <strong data-kg-unit-label></strong>';
          var sw = d.createElement('div');
          sw.className = 'kg-unit__swatches';
          sw.setAttribute('role', 'group');
          sw.setAttribute('aria-label', 'Kolor sztuki ' + (u + 1));
          colorValues.forEach(function (value) {
            var b = d.createElement('button');
            b.type = 'button';
            b.className = 'kg-unit__sw';
            b.style.setProperty('--sw', swatches[value] || '#D6CCBE');
            b.setAttribute('aria-label', value);
            b.setAttribute('title', value);
            b.setAttribute('data-unit', u);
            b.setAttribute('data-value', value);
            b.addEventListener('click', function () {
              var idx = parseInt(this.getAttribute('data-unit'), 10);
              units[idx][colorIndex] = this.getAttribute('data-value');
              render();
            });
            sw.appendChild(b);
          });
          row.appendChild(name);
          row.appendChild(sw);
          box.appendChild(row);
        }
        box.setAttribute('data-built', String(qty));
      }
      box.hidden = false;
      $$('.kg-unit', box).forEach(function (row, u) {
        var value = units[u] ? units[u][colorIndex] : '';
        $('[data-kg-unit-label]', row).textContent = value;
        $$('.kg-unit__sw', row).forEach(function (b) {
          var test = (units[u] || selected).slice();
          test[colorIndex] = b.getAttribute('data-value');
          var v = findVariant(test);
          b.disabled = !v || !v.available;
          b.setAttribute('aria-pressed', b.getAttribute('data-value') === value ? 'true' : 'false');
        });
      });
    }

    function render() {
      var variant = findVariant(selected);

      optionSets.forEach(function (fs, idx) {
        var lab = $('[data-kg-option-value]', fs);
        if (lab) lab.textContent = selected[idx] || '';
        $$('input', fs).forEach(function (inp) {
          var test = selected.slice();
          test[idx] = inp.value;
          var tv = findVariant(test);
          var pill = inp.closest('.kg-pill');
          if (pill) pill.classList.toggle('is-unavailable', !tv || !tv.available);
        });
      });

      if (variant) {
        $$('[data-kg-price]', root).forEach(function (el) { el.textContent = money(variant.price); });
        $$('[data-kg-compare]', root).forEach(function (el) {
          var has = variant.compare_at_price && variant.compare_at_price > variant.price;
          el.hidden = !has;
          if (has) el.textContent = money(variant.compare_at_price);
        });
      }

      var current = activeBundle();
      bundleInputs.forEach(function (inp) {
        var card = inp.closest('[data-kg-bundle]');
        var qty = qtyOf(inp);
        var list = [];
        if (inp === current) list = units;
        else for (var i = 0; i < qty; i++) list.push(selected.slice());
        var q = quote(list, discountOf(inp));
        var now = $('[data-kg-bundle-now]', card);
        if (now) now.textContent = money(q.final);
        var was = $('[data-kg-bundle-was]', card);
        if (was) { was.hidden = !(q.compare > q.final); was.textContent = money(q.compare); }
        var save = $('[data-kg-bundle-save]', card);
        if (save) { save.hidden = !(q.compare > q.final); save.textContent = 'Oszczędzasz ' + money(q.compare - q.final); }
        var each = $('[data-kg-bundle-each]', card);
        if (each) each.textContent = qty > 1 ? money(q.final / qty) + ' / szt.' : '';
        renderUnits(card, inp === current, qty);
      });

      var main = quote(units, discountOf(current));
      var total = main.final;
      addons.forEach(function (a) { if (a.checked) total += parseInt(a.getAttribute('data-price'), 10) || 0; });
      $$('[data-kg-total]').forEach(function (el) { el.textContent = money(total); });

      cta.disabled = !main.ok;
      if (ctaLabel) ctaLabel.textContent = main.ok ? cfg.ctaLabel : cfg.soldOutLabel;
      $$('[data-kg-sticky-btn]').forEach(function (b) { b.disabled = !main.ok; });
    }

    function onOptionChange(idx, value) {
      selected[idx] = value;
      resetUnits();
      render();
      var v = findVariant(selected);
      if (!v) return;
      if (gallery && v.featured_media) gallery.goToMedia(v.featured_media.id);
      if (window.history && history.replaceState && !cfg.preview) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    optionSets.forEach(function (fs, idx) {
      $$('input', fs).forEach(function (inp) {
        inp.addEventListener('change', function () { if (inp.checked) onOptionChange(idx, inp.value); });
      });
    });
    bundleInputs.forEach(function (inp) { inp.addEventListener('change', function () { resetUnits(); render(); }); });
    addons.forEach(function (a) { a.addEventListener('change', render); });

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
      var r = form.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) cta.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.hidden = true;
      var counts = {}, order = [];
      units.forEach(function (opts) {
        var v = findVariant(opts);
        if (!v) return;
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id]++;
      });
      var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
      addons.forEach(function (a) {
        if (a.checked) items.push({ id: parseInt(a.getAttribute('data-variant-id'), 10), quantity: 1 });
      });
      if (!items.length) { showError('Wybierz wariant, aby kontynuować.'); return; }
      if (cfg.preview) { showError('To jest podgląd — w sklepie produkt trafi teraz do koszyka.'); return; }

      cta.setAttribute('aria-busy', 'true');
      fetch(cfg.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || 'Nie udało się dodać do koszyka.');
          window.location.href = cfg.afterAdd === 'checkout' ? cfg.root + 'checkout' : cfg.cartUrl;
        })
        .catch(function (err) {
          cta.removeAttribute('aria-busy');
          showError(err.message || 'Wystąpił błąd. Spróbuj ponownie.');
        });
    });

    /* przyklejony pasek: pokazuje się, gdy główny przycisk zniknie u góry ekranu */
    var sticky = $('[data-kg-sticky]', root);
    if (sticky) {
      var ticking = false;
      var updateSticky = function () {
        ticking = false;
        var past = cta.getBoundingClientRect().bottom < 0;
        var footer = $('.kg-footer');
        if (past && footer && footer.getBoundingClientRect().top < window.innerHeight - 60) past = false;
        sticky.classList.toggle('is-visible', past);
        sticky.inert = !past;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(updateSticky); }
      }, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
      $$('[data-kg-sticky-btn]', sticky).forEach(function (b) {
        b.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else cta.click();
        });
      });
    }

    if (!activeBundle() && bundleInputs.length) bundleInputs[0].checked = true;
    resetUnits();
    render();
  }

  /* ---------- przewijane opinie ---------- */
  function initScrollers() {
    $$('[data-kg-scroller]').forEach(function (wrap) {
      var track = $('[data-kg-scroller-track]', wrap);
      if (!track) return;
      $$('[data-kg-scroll]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          track.scrollBy({ left: track.clientWidth * 0.8 * parseInt(b.getAttribute('data-kg-scroll'), 10), behavior: 'smooth' });
        });
      });
    });
  }

  function init() {
    initHeader();
    initRotator();
    initReveal();
    initEta();
    initScrollers();
    $$('[data-kg-product]').forEach(BuyBox);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();

  /* edytor motywu Shopify — ponowna inicjalizacja po zmianie sekcji */
  d.addEventListener('shopify:section:load', function (e) {
    $$('.kg-reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
    $$('[data-kg-product]', e.target).forEach(BuyBox);
    initEta();
    initScrollers();
  });
})();
